import * as React from 'react';
import { V3 } from '../../api_request';
import URLHelpers from '../../shared/url_helpers';

import CalloutEmbed from '../callout_embed';

interface Category {
  title: string;
  href: string;
  image: string;
}

interface Props {
  slug: string;
  child_slug?: string;
  narrow?: boolean;
}

export default class CategoryCalloutEmbed extends React.Component<Props, Category> {
  static defaultProps: Partial<Props> = {
    child_slug: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      title: null,
      href: null,
      image: null,
    };
  }

  componentDidMount() {
    if (this.props.child_slug) {
      this.requestCategory();
      return;
    }
    this.requestProductType();
  }

  buildMarketplaceLink() {
    return `/c/${this.props.slug}/${this.props.child_slug}`;
  }

  requestProductType() {
    V3.get(URLHelpers.productTypeCollectionHeaderPath(this.props.slug))
      .then((response) => { this.mapResponse(response); });
  }

  requestCategory() {
    const params = {
      root_slug: this.props.slug,
      child_slug: this.props.child_slug,
    };

    V3.get('/api/categories/collection_headers', params)
      .then((response) => { this.mapResponse(response.collection_headers[0]); });
  }

  mapResponse(collection_header) {
    this.setState({
      title: collection_header.title,
      href: this.buildMarketplaceLink(),
      image: collection_header._links.full_bleed_header_image.href,
    });
  }

  render() {
    if (!this.state.href) { return null; }

    return (
      <CalloutEmbed
        title={this.state.title}
        href={this.state.href}
        backgroundImage={this.state.image}
        narrow={this.props.narrow}
      />
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/embeds/callouts/category.tsx